import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Organisation, OrganisationService} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-organisations-picker',
    templateUrl: './organisations-picker.component.html',
    styleUrls: ['./organisations-picker.component.scss']
})
export class OrganisationsPickerComponent implements OnInit {

    @Output() public selectedOrganisationChanged = new EventEmitter<Organisation>();

    public get selectedOrganisation(): Organisation | undefined {
        return this._selectedOrganisation;
    }

    public set selectedOrganisation(val: Organisation | undefined) {
        this._selectedOrganisation = val;
        if (val) {
            this.selectedOrganisationChanged.emit(val);
        }
    }

    public organisations: Organisation[] = [];

    private _selectedOrganisation?: Organisation = undefined;

    public constructor(private readonly organisationsService: OrganisationService) { }

    public ngOnInit(): void {
        this.organisationsService.getOrganisations().subscribe(val => {
            this.organisations = val;
            if (this.organisations.length) {
                this.selectedOrganisation = this.organisations[0];
            }
        });
    }
}
